import { css } from '@emotion/react'
import { Theme } from '@mui/material/styles'

export const snackbarContainer = ({ theme }: { theme: Theme }) => css`
  width: 600px;
  box-shadow: ${theme.shadows[6]};
`
